import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from '@angular/common/http';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class DownloadService {
  constructor(
              public httpClient: HttpClient,
              public userFriendlyMsgs: UserFriendlyMsgs) { }

  getDownloadSignedURL(body) {
    const downloadUrl = `${environment.downloadServiceURL1}`;
    return this.httpClient.post(downloadUrl, body).catch(this.userFriendlyMsgs.errorHandler)
  }

  downloadDocumentWithSignedURL(url:string){
    const downloadDocumentURL = url;
    return this.httpClient.get(downloadDocumentURL).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/download/download.service.ts